<section class="icip-product" id="features" aria-label="Reporting & Analytics">
  <div class="icip-product__container" [class.is-nonbranded]="!isBranded">
    <div class="icip-product__content" [class.is-nonbranded]="!isBranded">
      <div class="icip-product__visual icip-reveal icip-reveal--left" appInView>
        <div class="icip-product__ring" [class.is-branded]="isBranded" aria-hidden="true"></div>
        <div
          class="icip-product__glow"
          [class.is-branded]="isBranded"
          aria-hidden="true"
        ></div>

        <div class="icip-product__phone">
          <img
            class="icip-product__phone-img"
            [src]="current.image"
            [alt]="current.title"
            [class.is-branded]="isBranded"
            draggable="false"
          />
        </div>

        <div class="icip-product__status" [class.is-branded]="isBranded" aria-label="Status">
          <span
            class="icip-product__status-dot"
            [class.is-branded]="isBranded"
            aria-hidden="true"
          ></span>
          {{ isBranded ? 'Active Solution' : 'Legacy Method' }}
        </div>
      </div>

      <div class="icip-product__details icip-reveal icip-reveal--right" appInView>
        <div class="icip-product__eyebrow" [class.is-nonbranded]="!isBranded">{{ current.label }}</div>
        <h2 class="icip-product__title">{{ current.title }}</h2>
        <p class="icip-product__desc">{{ current.description }}</p>

        <div class="icip-product__metrics">
          <div class="icip-product__metric" *ngFor="let m of current.metrics; trackBy: trackByMetricLabel">
            <div class="icip-product__metric-top">
              <div class="icip-product__metric-label">
                <span class="icip-product__metric-icon" aria-hidden="true">
                  <svg *ngIf="m.icon === 'trendingUp'" viewBox="0 0 24 24" width="16" height="16" fill="none">
                    <path d="M3 17L9 11L13 15L21 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21 7V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  </svg>
                  <svg *ngIf="m.icon === 'shield'" viewBox="0 0 24 24" width="16" height="16" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                    <path d="M9 12l2 2 4-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <svg *ngIf="m.icon === 'trendingDown'" viewBox="0 0 24 24" width="16" height="16" fill="none">
                    <path d="M3 7l6 6 4-4 8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <svg *ngIf="m.icon === 'alert'" viewBox="0 0 24 24" width="16" height="16" fill="none">
                    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                    <path d="M12 9v4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M12 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  </svg>
                </span>
                {{ m.label }}
              </div>
              <div class="icip-product__metric-value" [class.is-nonbranded]="!isBranded">{{ m.value }}%</div>
            </div>
            <div class="icip-product__bar">
              <div
                class="icip-product__bar-fill"
                [class.is-nonbranded]="!isBranded"
                [style.width.%]="m.value"
              ></div>
            </div>
          </div>
        </div>

        <div class="icip-product__reasons">
          <div class="icip-product__reasons-title">
            {{ isBranded ? 'Why This Changes Everything' : 'Why This Fails' }}
          </div>
          <div class="icip-product__reason" *ngFor="let r of current.reasons; trackBy: trackByReason">
            <span class="icip-product__reason-icon" aria-hidden="true">
              <svg *ngIf="isBranded" viewBox="0 0 24 24" width="16" height="16" fill="none">
                <path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <svg *ngIf="!isBranded" viewBox="0 0 24 24" width="16" height="16" fill="none">
                <path d="M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M6 6 18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </span>
            <span class="icip-product__reason-text">{{ r }}</span>
          </div>
        </div>
      </div>

      <div class="icip-product__switcher" aria-label="Toggle call type">
        <button
          type="button"
          class="icip-product__switch"
          [class.is-active]="activeType === 'branded'"
          (click)="setActive('branded')"
        >
          Branded
          <span class="icip-product__switch-underline" *ngIf="activeType === 'branded'" aria-hidden="true"></span>
        </button>
        <button
          type="button"
          class="icip-product__switch"
          [class.is-active]="activeType === 'nonbranded'"
          (click)="setActive('nonbranded')"
        >
          Non-Branded
          <span class="icip-product__switch-underline" *ngIf="activeType === 'nonbranded'" aria-hidden="true"></span>
        </button>
      </div>
    </div>
    <div class="icip-product__bg" aria-hidden="true"></div>
  </div>
  <div class="right-small-txt">*Statistics represented are examples only of the impact of Branded Calling. Results vary.</div>
</section>
